import { render, staticRenderFns } from "./TableRowMarginPerPatient.vue?vue&type=template&id=86faa368&lang=pug&"
import script from "./TableRowMarginPerPatient.vue?vue&type=script&lang=js&"
export * from "./TableRowMarginPerPatient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('86faa368')) {
      api.createRecord('86faa368', component.options)
    } else {
      api.reload('86faa368', component.options)
    }
    module.hot.accept("./TableRowMarginPerPatient.vue?vue&type=template&id=86faa368&lang=pug&", function () {
      api.rerender('86faa368', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/audiology-kpis/benchmarks/table-rows/TableRowMarginPerPatient.vue"
export default component.exports